import { IManagementStatisticsParam } from "@/api/management/type"
import dayjs from "@/utils/dayjs"

class DashboardConfig {
  selected: number = 30 // -1 表示所有时间；0 表示自定义日期，需要取 starting、ending Date 参数
  startingDate: Date = new Date()
  endingDate: Date = new Date()
  popupIDs: string[] = []

  reset() {
    this.selected = 30
    this.startingDate = new Date()
    this.endingDate = new Date()
    this.popupIDs = []
    console.warn("Reset dashboard search params config")
  }

  setQueryParams(selected: number, startingDate?: Date, endingDate?: Date) {
    this.selected = selected

    if (startingDate) {
      this.startingDate = startingDate
    }

    if (endingDate) {
      this.endingDate = endingDate
    }
  }

  getSearchParams(): IManagementStatisticsParam {
    if (this.selected > 0 || this.selected === -1) {
      return {
        day: this.selected === -1 ? 0 : this.selected,
        start_at_min: undefined,
        end_at_max: undefined,
      }
    }

    const startDayjs = dayjs(this.startingDate),
      endingDayjs = dayjs(this.endingDate)
    let startTime = startDayjs,
      endTime = endingDayjs.add(1, "d").subtract(1, "s")

    if (startDayjs.isAfter(endingDayjs)) {
      ;[startTime, endTime] = [endTime, startTime]
    }

    return {
      day: this.selected === -1 ? 0 : this.selected,
      start_at_min: undefined,
      end_at_max: undefined,
    }
  }
}

export default new DashboardConfig()
